import React, { useEffect } from 'react';
// import { Form, Checkbox, Select, Input } from 'antd';
import {
  Input,
  Form,
  Button,
  Row,
  Col,
  Typography,
  Select,
  Progress,
  message
} from 'antd';
// import AboutMe from './AboutMe';
// import Education from './Education';
import styles from './styles.module.less';
// import LeftImg from '@/common/assets/images/LeftImg1.png';
// import downloadIcon from '@/common/assets/images/DownloadIcon.svg';
// import EditIcon from '@/common/assets/images/EditIcon.svg';
import { useParams, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { createContactDetails } from '../redux/slice';
import { event } from '../../../utilities/gtag';

const Edit = ({ country_codes, user_data }) => {
  const [form] = Form.useForm();
  const { Text } = Typography;
  const params = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { createContactDetailsloading } = useSelector(
    (state) => state.editcontact
  );

  const onFinish = async (values) => {
    event({
      action: 'profile_creation', // event name
      category: 'Contact Creation',
      label: 'Profile Form Submitted',
      value: 1
    });
    // console.log('formData', values);

    const payload = {
      profile_id: params.id,
      phone_number_2: values.alternate_phoneNumber,
      address: values.address,
      phone_2_country_id: values.alternate_countryCode
    };

    console.log('Payload_familyDetails', payload);
    // onsubmit(values);
    // onsubmit(formData);
    try {
      console.log('Form Submitted:', payload);
      const response = await dispatch(createContactDetails(payload)).unwrap(); // Dispatch Redux action
      if (response?.success) {
        // localStorage.setItem('profile_id', response.profile_id); // Store profile ID
        // navigate(`/editpartner/${response.profile_id}`); // Redirect on success
        message.success(response.message || 'Form submitted successfully!');
        navigate(`/editpartner`);
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      message.error(
        error?.message || 'Failed to submit the form. Please try again.'
      );
    }
  };

  // Tabs Data //
  const routes = {
    'About Me': '/editprofile',
    'Family Details': '/editfamily',
    'Education & Career': '/editeducation',
    Horoscope: '/edithoroscope',
    Contact: '/editcontact',
    'Desired Partner': '/editpartner',
    Membership: '/membership_payment'
  };
  const handleSectionClick = (section) => {
    if (routes[section]) {
      navigate(routes[section]);
    }
  };
  const activeTab = Object.entries(routes).find(
    ([, path]) => location.pathname === path
  )?.[0];

  // Tabs Data

  const matUserData = localStorage.getItem('MAT-User');
  const matUserObject = JSON.parse(matUserData);
  const userName =
    matUserObject.user_details.first_name +
    ' ' +
    matUserObject.user_details.last_name;

  // const userCountry_Code = user_data?.phone_1_code?.id;
  // console.log('userCountry_Code', userCountry_Code);
  const userContact = matUserObject.user_details.phone_number;
  const userEmail = matUserObject.user_details.email;
  console.log('user_data', user_data);
  useEffect(() => {
    if (user_data?.Profiles?.[0]) {
      console.log('user_data?.address', user_data);
      form.setFieldsValue({
        countryCode: user_data?.phone_1_code?.id,
        alternate_countryCode: user_data?.phone_2_code?.id,
        alternate_phoneNumber: user_data?.phone_number_2,
        address: user_data?.address
        // employmentType: education_details?.employed_in
      });
    }
  });

  const percent = user_data?.user_score;
  // const conicColors = {
  //   '0%': '#87d068',
  //   '50%': '#ffe58f',
  //   '100%': '#ffccc7'
  // };
  const getStrokeColor = (percent) => {
    if (percent <= 30) return '#ff4d4f'; // Red
    if (percent <= 50) return '#fa8c16'; // Orange
    if (percent <= 80) return '#fadb14'; // Yellow
    return '#52c41a'; // Green
  };

  // const matUserData = localStorage.getItem('MAT-User');
  // const matUserObject = JSON.parse(matUserData);
  // const profile_unique_id = matUserObject?.user_details?.profile_unique_id;

  return (
    <div className={styles.maincontainer}>
      <div className={styles.editOuter}>
        <div className={styles.singleContainer}>
          <Row
            gutter={24}
            style={{ width: '100%' }}
            className={styles.aboutimgstyles}
          >
            <Col
              xl={7}
              lg={24}
              md={24}
              sm={24}
              xs={24}
              className={styles.leftspace}
            >
              <div className={styles.leftimgcontainer}>
                {/* <img src={LeftImg} /> */}
                <div className={styles.overlayText}>
                  <h2 className={styles.title}>THE TALE OF</h2>
                  <h1 className={styles.bigTitle}>TWO</h1>
                </div>
              </div>
            </Col>
            <Col
              xl={16}
              lg={24}
              md={24}
              sm={24}
              xs={24}
              className={styles.leftspace}
            >
              <div className={styles.detailSide}>
                <div className={styles.detailName}>
                  <div className={styles.nameflex}>
                    <div className={styles.idname}>
                      <h1 className={styles.dName}> {userName} </h1>
                      {/* <span> {profile_unique_id} </span> */}
                    </div>
                    {/* <div className={styles.matchpercent}>
                      <h6>
                        <span>96%</span> Away to find the right match
                      </h6>
                    </div> */}
                    <Row gutter={[8, 8]} wrap>
                      <Col className={styles.progressname}>
                        <Progress
                          size="small"
                          type="circle"
                          percent={percent}
                          // strokeColor={conicColors}
                          strokeColor={getStrokeColor(percent)}
                        />
                        <h6 className={styles.matchpercent}>
                          away to find your life partner
                        </h6>
                      </Col>
                    </Row>
                  </div>
                  <div className={styles.changes}>
                    {/* <div className={styles.textContainer}>
                      <img
                        src={EditIcon}
                        alt="Edit Profile"
                        className={styles.icon}
                      />
                      <div>Edit</div>
                    </div> */}

                    {/* <div className={styles.vBorder}></div>

                    <div className={styles.textContainer}>
                      <img
                        src={downloadIcon}
                        alt="Download Profile"
                        className={styles.icon}
                      />
                      <div>Download</div>
                    </div> */}
                  </div>
                </div>
                <div>
                  <div className={styles.detailsOuter}>
                    <div className={styles.detailsInner}>
                      <div className={styles.detailsInside}>
                        {/* Tabs Content */}
                        <div className={styles.searchTab}>
                          {Object.keys(routes).map((section) => (
                            <div
                              key={section}
                              className={`${styles.searchTabHeader} ${
                                activeTab === section ? styles.activeTab : ''
                              }`}
                              onClick={() => handleSectionClick(section)}
                            >
                              {section}
                            </div>
                          ))}
                        </div>
                        {/* Tabs Content */}

                        <div
                        //   style={{
                        //     padding: '20px 107px 0px 550px',
                        //     fontFamily: 'teachers'
                        //   }}
                        >
                          <Form
                            form={form}
                            layout="vertical"
                            onFinish={onFinish}
                          >
                            <Row gutter={24}>
                              <Col xl={12} lg={12} md={24} sm={24} xs={24}>
                                {/* <Text className={styles.labels} strong>
                              Phone Number
                            </Text>
                            <Form.Item name="starSign" className="">
                              <Input
                                placeholder="Enter Phone Number"
                                className={styles.fields}
                              />
                            </Form.Item> */}
                                <Form.Item
                                  label="Phone Number"
                                  name="phone"
                                  rules={[
                                    {
                                      required: false,
                                      message: 'Please enter your phone number'
                                    }
                                  ]}
                                  className={styles.fullWidthItem}
                                >
                                  <Input.Group
                                    compact
                                    className={styles.customInputContainer}
                                  >
                                    <Form.Item
                                      name="countryCode"
                                      noStyle
                                      // initialValue={3}
                                    >
                                      <Select
                                        style={{ width: '20%' }}
                                        showSearch
                                        disabled
                                        placeholder="Select country code"
                                        className={styles.codefiled}
                                        optionFilterProp="children"
                                        getPopupContainer={(triggerNode) =>
                                          triggerNode.parentNode
                                        } // Ensures correct styling
                                        dropdownStyle={{ borderRadius: '8px' }} // Apply radius to dropdown
                                        filterOption={(input, option) =>
                                          option.children
                                            .toLowerCase()
                                            .includes(input.toLowerCase())
                                        }
                                      >
                                        {country_codes?.length
                                          ? country_codes?.map(
                                              (code, index) => {
                                                return (
                                                  <option
                                                    value={code?.id}
                                                    key={index}
                                                  >
                                                    {code?.country_code}
                                                  </option>
                                                );
                                              }
                                            )
                                          : ''}
                                      </Select>
                                    </Form.Item>
                                    {/* <span className={styles.divider}>|</span> */}
                                    <Form.Item
                                      name="phoneNumber"
                                      noStyle
                                      initialValue={userContact}
                                    >
                                      <Input
                                        placeholder="Enter phone number"
                                        type="tel"
                                        // value={userContact}
                                        disabled
                                        maxLength={10}
                                        style={{
                                          width: '80%',
                                          marginLeft: '-6px'
                                        }}
                                        // , padding: '5px 0 5px 10px'
                                      />
                                    </Form.Item>
                                  </Input.Group>
                                </Form.Item>
                              </Col>
                              <Col xl={12} lg={12} md={24} sm={24} xs={24}>
                                {/* <Text className={styles.labels} strong>
                              Alternate Number
                            </Text>
                            <Form.Item name="starSign" className="">
                              <Input
                                placeholder="Enter AlterName Number"
                                className={styles.fields}
                              />
                            </Form.Item> */}
                                <Form.Item
                                  label="Alternate Number"
                                  name="alternatephone"
                                  rules={[
                                    {
                                      required: false,
                                      message: 'Please enter your phone number'
                                    }
                                  ]}
                                  className={styles.fullWidthItem}
                                >
                                  <Input.Group
                                    compact
                                    className={styles.customInputContainer}
                                  >
                                    <Form.Item
                                      name="alternate_countryCode"
                                      noStyle
                                      // initialValue="+91"
                                      initialValue={1}
                                    >
                                      <Select
                                        // style={{ width: '20%' }}
                                        showSearch
                                        placeholder="Select country code"
                                        className={styles.codefiled}
                                        optionFilterProp="children"
                                        getPopupContainer={(triggerNode) =>
                                          triggerNode.parentNode
                                        } // Ensures correct styling
                                        dropdownStyle={{ borderRadius: '8px' }} // Apply radius to dropdown
                                        filterOption={(input, option) =>
                                          option.children
                                            .toLowerCase()
                                            .includes(input.toLowerCase())
                                        }
                                      >
                                        {country_codes?.length
                                          ? country_codes?.map(
                                              (code, index) => {
                                                return (
                                                  <option
                                                    value={code?.id}
                                                    key={index}
                                                  >
                                                    {code?.country_code}
                                                  </option>
                                                );
                                              }
                                            )
                                          : ''}
                                      </Select>
                                    </Form.Item>
                                    {/* <span className={styles.divider}>|</span> */}
                                    <Form.Item
                                      name="alternate_phoneNumber"
                                      noStyle
                                      rules={[
                                        {
                                          required: false,
                                          message:
                                            'Please enter a valid phone number'
                                        },
                                        {
                                          pattern: /^[0-9]{10}$/,
                                          message:
                                            'Phone number must be up to 10 digits'
                                        }
                                      ]}
                                    >
                                      <Input
                                        placeholder="Enter alternate phone number"
                                        type="tel"
                                        maxLength={10}
                                        // style={{
                                        //   width: '80%',
                                        //   marginLeft: '-6px'
                                        // }}
                                        // , padding: '5px 0 5px 10px'
                                        className={styles.numfield}
                                      />
                                    </Form.Item>
                                  </Input.Group>
                                </Form.Item>
                              </Col>
                            </Row>

                            <Row gutter={24}>
                              <Col span={24}>
                                <Text className={styles.labels}>Email</Text>
                                <Form.Item
                                  name="email"
                                  className=""
                                  initialValue={userEmail}
                                >
                                  <Input
                                    disabled
                                    placeholder="Enter e-mail"
                                    className={styles.fields}
                                    // readOnly
                                  />
                                </Form.Item>
                              </Col>
                            </Row>
                            <Row gutter={24}>
                              <Col span={24}>
                                <Text className={styles.labels}>
                                  Current Address
                                </Text>
                                <Form.Item name="address" className="">
                                  <Input
                                    placeholder="Enter currect address"
                                    className={styles.fields}
                                  />
                                </Form.Item>
                              </Col>
                            </Row>
                            <br />

                            <Form.Item>
                              <Button
                                type="primary"
                                htmlType="submit"
                                className={styles.submitbutton}
                                loading={createContactDetailsloading}
                                disabled={createContactDetailsloading}
                              >
                                Save & Next
                              </Button>
                            </Form.Item>
                          </Form>
                        </div>
                      </div>
                    </div>
                    {/* </Form> */}
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
};

export default Edit;
